import { Message, MessageBox } from "element-ui";
import { readPsd } from "ag-psd";
import potrace from "potrace";
import PerspT from 'perspective-transform';
import CryptoJS from 'crypto-js'
import md5 from "js-md5";
import OSS from "@/utils/oss.js";
import { getCurrentTime, randomString } from "@/utils/util";
import { apiAliToken } from "@/api/app";
import { calculateCanvasSize, handleArray, calculateCenterReduce, getSmartObjectMatrix, calculatePerspectiveTransform, combineTransforms, calculateTransform } from './tools.js';
let ossClass = null
let file_id = ''
let file_dir = randomString(12, 1)
export const readPsdFile = async (file) => {
    try {
        // decryptData('https://fqpod.oss-cn-guangzhou.aliyuncs.com/uploads/images/20251203/jnYUJMezOXwM/23deba14b84efd74ef943ffd967345bd.json')
        // return
        let ossConfig = await apiAliToken();
        ossClass = new OSS(ossConfig);
        file_id = md5(file.file.name + randomString(10))
        const buffer = await file.file.arrayBuffer();
        const psd = readPsd(buffer, { useImageData: false });
        console.log("🚀 ~ readPsdFile ~ psd:", psd)
        if (psd.width != 1500 || psd.height != 1500) {
            Message.error('当前PSD文件尺寸不是1500*1500，请注意检查文件尺寸')
        }
        const thumbBlob = base64ToBlob(psd.canvas.toDataURL('image/jpeg'))
        const layerAll = getAllLayers(psd);
        const promiseArr = [];
        for (let layer of layerAll) {
            if (!layer.hidden) {
                promiseArr.push(readGroup(layer));
            }
        }
        const psdDatas = await Promise.all(promiseArr);
        let data = {
            width: psd.width,
            height: psd.height,
            psdDatas: psdDatas
        }

        const thumbRes = await ossClass.uploadPsdEffect(thumbBlob, `${file_dir}/${file_id}-thumb.png`)
        const jsonBlob = createBlobFile(encryptData(data), `${file_id}.json`)
        const jsonRes = await ossClass.uploadPsdEffect(jsonBlob, `${file_dir}/${file_id}.json`)
        return {
            file_name: file.file.name.replace(/\.psd$/, ''),
            file_id: file_id,
            url: jsonRes.url,
            thumb: thumbRes.url,
        }
        // return
    } catch (error) {
        Message.error(error)
        console.error('加载PSD文件时出错:', error);
    }
}

const base64ToBlob = (base64Data, contentType = 'image/png', sliceSize = 512) => {
    const parts = base64Data.split(';base64,');
    const base64 = parts.length > 1 ? parts[1] : base64Data;
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
}

const encryptData = (originalData) => {
    // 将JSON对象转换为字符串
    const jsonString = JSON.stringify(originalData)
    // 使用AES加密
    const encryptedText = CryptoJS.AES.encrypt(
        jsonString,
        'FQ-POD-112233'
    ).toString()
    return encryptedText
}

export const decryptData = async (url) => {
    try {
        let response = await fetch(url)
        let json = await response.text()
        // 解密
        const bytes = CryptoJS.AES.decrypt(json, 'FQ-POD-112233')
        const decryptedString = bytes.toString(CryptoJS.enc.Utf8)
        // 将字符串转换回JSON对象
        let result = JSON.parse(decryptedString)
        return result
    } catch (error) {
        console.error('解密失败:', error)
    }
}

const createBlobFile = (data, name) => {
    const blob = new Blob([data], { type: "application/json" });
    const file = new File([blob], name, { type: "application/json" });
    return file
}

const getAllLayers = (psd) => {
    let layerArr = [];
    if (psd.children?.length) {
        for (let child of psd.children) {
            if (!child.hidden) {
                if (child.children?.length && !child.children.find(child => child.placedLayer)) {
                    layerArr = layerArr.concat(getAllLayers(child));
                } else {
                    layerArr.push(child);
                }
            }
        }
    }
    return layerArr;
}

const readGroup = async (layer) => {
    try {
        let item = {
            N: layer.name,
            T: '',
            BM: layer.blendMode || 'normal',
            O: layer.opacity,
            S: layer.hidden,
            X: layer.left,
            Y: layer.top
        };

        // 蒙版
        if (layer.mask) {
            const maskCanvas = layer.mask.canvas.toDataURL()
            const path = await createPath(maskCanvas, layer.name);
            const { left, top, right, bottom } = layer.mask;
            item.MK = { path: path, left, top, width: right - left, height: bottom - top };
        }

        //判断是否是组
        if (layer.children?.length) {
            item.T = 'Group';
            item.CL = await createLayerItem(layer);
        } else {
            if (layer.placedLayer) {
                item = await buildLayerItem(layer)
            } else {
                item.T = 'Layer';
                const IMGBlob = base64ToBlob(layer.canvas.toDataURL("image/png"))
                const IMG = await ossClass.uploadPsdEffect(IMGBlob, `${file_dir}/${file_id}-${randomString(6, 4)}.png`)
                item.IMG = IMG.url
            }

        }
        return item;
    } catch (error) {
        console.log("🚀 ~ readGroup ~ error:", error)

    }
}

const createLayerItem = async (value) => {
    try {
        const children = value.children;
        const promises = []
        for (let child of children) {
            if (!child.hidden) {
                promises.push(buildLayerItem(child));
            }
        }
        return await Promise.all(promises);
    } catch (error) {
        console.log("🚀 ~ createLayerItem ~ error:", error)
    }
};

const buildLayerItem = async (value) => {
    try {
        const {
            blendMode: BM,
            name: N,
            canvas,
            left: X,
            top: Y,
            opacity: O,
            placedLayer,
        } = value;
        //类型
        const T = value.placedLayer && value.placedLayer.transform.length ? 'SmartObject' : 'Layer';
        //智能对象原始宽高
        const OS = value.placedLayer ? [value.placedLayer.width, value.placedLayer.height] : [value.width, value.height];
        //当前图像实际宽
        const W = value.canvas.width;
        //当前图像实际高
        const H = value.canvas.height;
        const IMGBlob = base64ToBlob(canvas.toDataURL('image/png'))
        const IMGRes = await ossClass.uploadPsdEffect(IMGBlob, `${file_dir}/${file_id}-${randomString(6, 4)}.png`)
        const IMG = IMGRes.url
        let resp = await fetch(IMG + '?x-oss-process=image/info')
        let result = await resp.json()
        let WT = [result.ImageWidth.value, result.ImageHeight.value]
        let item = { N, T, BM, O, X, Y, W, H, OS, IMG, WT };
        if (placedLayer?.transform) {
            //形变矩阵
            let M = []
            //中心点坐标
            let C = []
            //形变网格点
            const PS = placedLayer?.warp?.customEnvelopeWarp?.meshPoints
            let matrix = []
            let bounds = placedLayer?.warp?.bounds
            let originalPoints = [
                bounds.left.value, bounds.top.value,
                bounds.right.value, bounds.top.value,
                bounds.right.value, bounds.bottom.value,
                bounds.left.value, bounds.bottom.value
            ]
            if (PS && PS.length > 0) {
                const result = calculateCanvasSize(PS);
                bounds = result.bounds;
                originalPoints = [
                    bounds.left.value, bounds.top.value,
                    bounds.right.value, bounds.top.value,
                    bounds.right.value, bounds.bottom.value,
                    bounds.left.value, bounds.bottom.value
                ]
            }
            const persp = PerspT(originalPoints, placedLayer.nonAffineTransform || placedLayer.transform);
            matrix = persp.coeffs
            M = [
                [matrix[0], matrix[1], matrix[2]],
                [matrix[3], matrix[4], matrix[5]],
                [matrix[6], matrix[7], matrix[8]],
            ]
            item = { ...item, M, C, PS }
        }

        return item
    } catch (error) {
        console.log("🚀 ~ buildLayerItem ~ error:", error)

    }
};
// 2. 辅助函数：高斯消元法求解线性方程组 Ax = B
function solveGaussian(A, B) {
    const n = A.length;
    // 增广矩阵
    for (let i = 0; i < n; i++) {
        A[i].push(B[i]);
    }

    for (let i = 0; i < n; i++) {
        // 寻找主元
        let maxEl = Math.abs(A[i][i]);
        let maxRow = i;
        for (let k = i + 1; k < n; k++) {
            if (Math.abs(A[k][i]) > maxEl) {
                maxEl = Math.abs(A[k][i]);
                maxRow = k;
            }
        }

        // 交换行
        let tmp = A[maxRow];
        A[maxRow] = A[i];
        A[i] = tmp;

        // 消元
        for (let k = i + 1; k < n; k++) {
            let c = -A[k][i] / A[i][i];
            for (let j = i; j < n + 1; j++) {
                if (i === j) {
                    A[k][j] = 0;
                } else {
                    A[k][j] += c * A[i][j];
                }
            }
        }
    }

    // 回代
    const x = new Array(n).fill(0);
    for (let i = n - 1; i > -1; i--) {
        let sum = 0;
        for (let j = i + 1; j < n; j++) {
            sum += A[i][j] * x[j];
        } // @ts-ignore
        x[i] = (A[i][n] - sum) / A[i][i];
    }
    return x;
}

// 3. 计算透视变换矩阵的主函数
function calculatePerspectiveMatrix(src, dst) {
    // 构建 8x8 矩阵 A 和 向量 B
    // H = [h0, h1, h2, h3, h4, h5, h6, h7, 1]
    // 使得: x' = (h0*x + h1*y + h2) / (h6*x + h7*y + 1)
    //       y' = (h3*x + h4*y + h5) / (h6*x + h7*y + 1)

    let A = [];
    let B = [];

    for (let i = 0; i < 4; i++) {
        const sx = src[i * 2];
        const sy = src[i * 2 + 1];
        const dx = dst[i * 2];
        const dy = dst[i * 2 + 1];

        // 每一个点提供两个方程
        // h0*sx + h1*sy + h2 - h6*sx*dx - h7*sy*dx = dx
        A.push([sx, sy, 1, 0, 0, 0, -sx * dx, -sy * dx]);
        B.push(dx);

        // h3*sx + h4*sy + h5 - h6*sx*dy - h7*sy*dy = dy
        A.push([0, 0, 0, sx, sy, 1, -sx * dy, -sy * dy]);
        B.push(dy);
    }

    // 求解 h0 ~ h7 (假设 h8 = 1)
    const h = solveGaussian(A, B);

    // h 数组包含了 [h0, h1, h2, h3, h4, h5, h6, h7]
    // 添加 h8 = 1
    h.push(1.0);

    return [
        [h[0], h[1], h[2]],
        [h[3], h[4], h[5]],
        [h[6], h[7], h[8]]
    ];
}



const potraceLoadImage = (trace, img) => {
    return new Promise((resolve, reject) => {
        trace.loadImage(img, (err) => {
            if (err) {
                reject(err);
            } else {
                resolve();
            }
        });
    });
};


const createPath = async (img) => {
    try {
        const trace = new potrace.Potrace();
        trace.setParameters({
            color: "",
            blackOnWhite: false,
        });
        await potraceLoadImage(trace, img);
        const pathTag = trace.getPathTag();
        const match = pathTag.match(/d="([^"]*)"/);
        return match ? match[1] : "";
    } catch (error) {
        console.error("创建路径时出错:", error);
        throw error;
    }
}